<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Kategorie</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja kategorii</template>
          <template v-else>Dodawanie kategorii</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/kategorie')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Podaj nazwę kategorii
            </h4>
            <validation-observer ref="categories-form" tag="form">
              <d-row>
                <d-col>
                  <div class="form-group">
                    <label for="name">
                      Nazwa:
                    </label>
                    <validation-provider
                            rules="required"
                            name="name"
                            v-slot="{ errors }">
                      <d-input
                              :state="errors.length ? 'invalid' : null"
                              v-model="data.name" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col>
                  <validation-provider
                          :rules="'required'"
                          :name="'type_id'"
                          v-slot="{ errors }">
                    <div class="form-group" style="margin-bottom: 2.5rem;">
                      <label class="title-box" :for="data.type_id">
                        Uwzględniony raport:
                      </label>
                      <v-select
                              :options="used_reports"
                              v-model="data.used_report"
                              :reduce="option => option.id"
                              placeholder="Wybierz raport"
                              label="id">
                        <template #search="{attributes, events}">
                          <d-input
                                  class="input-for-select"
                                  :state="errors.length ? 'invalid' : null"
                                  :required="!data.type_id"
                                  v-bind="attributes"
                                  v-on="events"
                          />
                        </template>
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            {{ option.name }}
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ option.name }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                    <div class="invalid-feedback" style="display: block; margin-top: -1.4rem;">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </d-col>
              </d-row>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'category-form',
  computed: {
    allDataLoaded () {
      return this.loaded && this.loadedCategories;
    },
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      data: {
        name: '',
        used_report: ''
      },
      loaded: false,
      loadError: false,
      categories: [],
      used_reports: [],
      loadedCategories: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
    this.getUsedReports();
    this.loadAdditionalData();
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/services/categories/item/',
        instanceFields: ['id', 'name', 'used_report'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/categories/items',
        params: {
          pagination: false
        },
        outputKey: 'categories',
        loadedKey: 'loadedCategories',
        errorKey: 'loadError',
        successAction: () => {
          if (this.data.id) {
            this.categories = this.categories.filter(category => category.id !== this.category_id);
          }
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['categories-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/services/categories/update/' + this.id : '/services/categories/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano kategorie',
        successText: 'Wybrana kategoria została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje kategorii nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/kategorie')
        }
      });
    },
    getUsedReports () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/categories/used-reports',
        outputKey: 'used_reports',
        params: {
          pagination: false,
        },
        noPagination: true,
        responseKey: false
      });
    },
    prepareFormDataToSend () {
      return {
        name: this.data.name,
        used_report: this.data.used_report
      };
    }
  }
};
</script>
